export const listProducts = `
   query listProducts($filter: ProductsFilterInput) {
       listProducts(filter: $filter) {
           items {
              id
              name
              status
              shortDescription
              longDescription
              productImage
              freeTrial
              lineItems {
                items {
                  id
                  productId
                  productFeatureId
                  productFeature {
                    id
                    name
                    description
                  }
                  position
                }
                nextToken
              }
           }
         nextToken
       }
   }
`;

export const listApplicationProducts = `
   query listApplicationProducts($filter: ApplicationProductsFilterInput) {
       listApplicationProducts(filter: $filter) {
           items {
              id
              applicationId
              productId
              product {
                id
                name
              }
              applicationProductStatus
              position
           }
         nextToken
       }
   }
`;

export const getProduct = `
   query getProduct($id:ID!) {
       getProduct(id:$id) {
            id
            name
            status
            shortDescription
            longDescription
            productImage
            freeTrial
            lineItems {
              items {
                id
                productId
                productFeatureId
                productFeature {
                  id
                  name
                  description
                }
                position
              }
              nextToken
            }
       }
}`;


